export const brandColors = {
  primary: {
    main: '#34AAF2',
    light: '#34AAF2',
    dark: '#0B7DC4',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FF00AE',
    light: '#FF00AE',
    dark: '#B30079',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#815FF4',
    light: '#815FF4',
    dark: '#5131B9',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#3BF29D',
    light: '#3BF29D',
    dark: '#15C474',
    contrastText: '#0F172A',
  },
  warning: {
    main: '#FFB547',
    light: '#FFB547',
    dark: '#D18A1A',
    contrastText: '#1F2937',
  },
  error: {
    main: '#FF4D4F',
    light: '#FF4D4F',
    dark: '#C41316',
    contrastText: '#FFFFFF',
  },
  neutral: {
    darkest: '#0F172A',
    darker: '#1F2937',
    dark: '#475569',
    base: '#94A3B8',
    light: '#CBD5F5',
    lighter: '#E2E8F0',
    lightest: '#F5F9FF',
    white: '#FFFFFF',
  },
}

export const surfaceTokens = {
  background: '#F6F5F4',
  paper: '#FFFFFF',
  border: '#E5E7EB',
  shadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
}

export const spacingScale = {
  unit: 8,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
}

export const typographyScale = {
  fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
  weights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  headings: {
    h1: { fontSize: '3rem', lineHeight: 1.1 },
    h2: { fontSize: '2.5rem', lineHeight: 1.2 },
    h3: { fontSize: '2rem', lineHeight: 1.25 },
    h4: { fontSize: '1.75rem', lineHeight: 1.3 },
    h5: { fontSize: '1.5rem', lineHeight: 1.35 },
    h6: { fontSize: '1.25rem', lineHeight: 1.4 },
  },
  body: {
    default: { fontSize: '1rem', lineHeight: 1.6 },
    small: { fontSize: '0.875rem', lineHeight: 1.5 },
  },
}
